<div *ngIf="showPrompt" class="pwa-install-prompt" [class.ios]="isIos">
  <div class="pwa-content">
    <div class="app-info">
      <img
        src="assets/images/app_icon.png"
        alt="ABC Talkies"
        class="app-icon"
      />
      <div class="text-content">
        <h3>Install ABC Talkies</h3>
        <p *ngIf="!isIos">
          Install our app for a better, fullscreen experience.
        </p>
        <p *ngIf="isIos">
          Install this app on your iPhone: tap
          <span class="share-icon"></span> and then
          <strong>Add to Home Screen</strong>.
        </p>
      </div>
    </div>
    <div class="actions" *ngIf="!isIos">
      <button class="btn-dismiss" (click)="dismiss()">Not Now</button>
      <button class="btn-install" (click)="install()">Install</button>
    </div>
    <div class="actions" *ngIf="isIos">
      <button class="btn-dismiss full-width" (click)="dismiss()">Close</button>
    </div>
  </div>
</div>
